<div class="main-container container-fluid">
  <div class="row rr-container-white">
    <div class="col-sm-6 col-xl-8 ml-4">
      <h5 class="">
        <span *ngIf="!isBulkEdit">
          <i class="fas fa-table px-2"></i> Data Entry
        </span>

        <span *ngIf="isBulkEdit">
          <i class="fas fa-list-alt px-2"></i> Bulk Edit
        </span>
      </h5>
      <p>Select a field to modify run tickets in that field.</p>
    </div>
  </div>

  <div class="row pt-2" style="padding-bottom: 100px; overflow: hidden">
    <div class="col-12">
      <div class="d-flex flex-wrap flex-column flex-lg-row justify-content-between align-items-center p-4">
        <div class="d-flex flex-wrap flex-column flex-sm-row align-items-center">
          <div class="btn-group" role="button">
            <button class="btn fw-700" type="button" (click)="changeFieldView('favorites')" [class.btn-primary]="fieldView == 'favorites'" [class.btn-outline-secondary]="fieldView != 'favorites'">
              <i [class.fas]="fieldView == 'favorites'" [class.far]="fieldView != 'favorites'" class="fa-star"></i>
              Favorites
            </button>
            <button class="btn fw-700" type="button" (click)="changeFieldView('all')" [class.btn-secondary]="fieldView == 'all'" [class.btn-outline-secondary]="fieldView != 'all'">All fields</button>

          </div>
          <div class="form-inline p-2 ml-2">
            <input class="form-control" style="min-width: 20vw; font-size: 0.95em; height: calc(1.5em + .75rem + 5px); " type="text" trim="blur" name="fieldQuery" [(ngModel)]="filters.fieldQuery" (blur)="updateFilters('query', filters.fieldQuery)" placeholder="Search by field name...">
          </div>
          <!--<div class="d-flex align-items-center">
            <button class="btn btn-outline-dark" [class.view-selected]="!listDisplay" [class.btn-outline-dark]="!listDisplay" (click)="swapViews(false)" title="Gallery view"><i class="fas fa-th-large"></i></button>
            <button class="btn btn-outline-dark" [class.view-selected]="listDisplay" [class.btn-outline-dark]="listDisplay" (click)="swapViews(true)" title="List view"><i class="fas fa-bars"></i></button>
          </div>-->
        </div>
      </div>

      <div *ngIf="fieldView == 'favorites'">
        <div class="card-body p-2">
          <div *ngIf="isLoading">
            <app-loading-indicator [large]="true" [message]="'Loading your fields'"></app-loading-indicator>
          </div>
          <div *ngIf="!isLoading">
            <div *ngIf="errorGetFields else noErrorMyFields" class="text-center text-danger">
              <p><strong>{{errorGetFieldsMessage}}</strong></p>
            </div>
            <ng-template #noErrorMyFields>
              <div *ngIf="(userFields && userFields.length > 0); else noFavoriteFields" class="col-md-12">
                <app-preview-field [fieldArray]="userFields" [isUserFields]=true [isAllFields]=false [userProfile]="userProfile" [listDisplay]="listDisplay" [filters]="filters" (updateUserFields)="updateUserFieldsHandler($event)"></app-preview-field>
              </div>
              <ng-template #noFavoriteFields>
                <div class="text-center p-4">
                  <div class="py-4">
                    <img src="/assets/no-data-img.svg" alt="No data image" style="height: 125px;" />
                  </div>
                  <p>You do not currently have any Favorite Fields. View or start adding from <a class="btn btn-sm btn-secondary rr-cursor" role="button" (click)="changeFieldView('all')" style="color: white;">All Fields</a></p>
                </div>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </div>

      <div *ngIf="fieldView == 'all'">
        <div class="card-body p-2">
          <div *ngIf="isLoading || isLoadingAllFields">
            <app-loading-indicator [large]="true" [message]="'Loading all fields'"></app-loading-indicator>
          </div>
          <div *ngIf="!isLoading && !isLoadingAllFields">
            <div *ngIf="errorGetFields else noErrorAllFields" class="text-center text-danger">
              <p><strong>{{errorGetFieldsMessage}}</strong></p>
            </div>
            <ng-template #noErrorAllFields>
              <div *ngIf="(receivedFields && receivedFields.length > 0); else noReceivedFields" class="col-md-12">
                <app-preview-field [fieldArray]="receivedFields" [isAllFields]=true [userProfile]="userProfile" [listDisplay]="listDisplay" [filters]="filters" (updateUserFields)="updateUserFieldsHandler($event)"></app-preview-field>
              </div>
              <ng-template #noReceivedFields>
                <div class="text-center p-4">
                  <div class="text-center p-4">
                    <div class="py-4">
                      <img src="/assets/no-data-img.svg" alt="No data image" style="height: 125px;" />
                    </div>
                    <p>It appears no fields have been created for your company yet.</p>
                  </div>
                </div>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
